import React, { useState } from "react";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import TagIcon from "@mui/icons-material/Tag";
import ListItemText from "@mui/material/ListItemText";
import Skeleton from "@mui/material/Skeleton";
import Button from "@mui/material/Button";
import { useMediaQuery } from "@mui/material";

import { SideBlock } from "./SideBlock";
import { Link } from "react-router-dom";

export const TagsBlock = ({ items, isLoading = true }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const TAGS_PER_PAGE = 6;
  const isMobile = useMediaQuery("(max-width:600px)");

  const startIdx = currentPage * TAGS_PER_PAGE;
  const endIdx = startIdx + TAGS_PER_PAGE;
  const displayedTags = items.slice(startIdx, endIdx);

  const handleNext = () => setCurrentPage((prev) => prev + 1);
  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 0));

  return (
    <SideBlock title="Теги">
      <List>
        {(isLoading ? [...Array(5)] : displayedTags).map((name, i) => (
          <Link
            key={isLoading ? i : name}
            style={{ textDecoration: "none", color: "black" }}
            to={`/tags/${name}`}
          >
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon sx={{ minWidth: isMobile ? "12px" : "56px" }}>
                  <TagIcon sx={{ fontSize: isMobile ? "12px" : "24px" }} />
                </ListItemIcon>
                {isLoading ? (
                  <Skeleton width={100} />
                ) : (
                  <ListItemText
                    primary={name}
                    primaryTypographyProps={{
                      sx: {
                        fontSize: isMobile ? "0.8rem" : "1rem",
                        lineHeight: 1.2,
                      },
                    }}
                  />
                )}
              </ListItemButton>
            </ListItem>
          </Link>
        ))}
      </List>
      {!isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: isMobile ? "center" : "space-evenly",
            marginTop: 10,
            gap: isMobile ? "10px" : "0",
            flexWrap: "wrap",
          }}
        >
          <Button
            variant="outlined"
            onClick={handlePrev}
            disabled={currentPage === 0}
          >
            Назад
          </Button>
          <Button
            variant="outlined"
            onClick={handleNext}
            disabled={endIdx >= items.length}
          >
            Вперед
          </Button>
        </div>
      )}
    </SideBlock>
  );
};
